import { render } from "./TermsPrivacy.vue?vue&type=template&id=6eba6fe0&scoped=true"
import script from "./TermsPrivacy.vue?vue&type=script&lang=js"
export * from "./TermsPrivacy.vue?vue&type=script&lang=js"

import "./TermsPrivacy.vue?vue&type=style&index=0&id=6eba6fe0&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eba6fe0"]])

export default __exports__